export const tilesUrl = process.env.NODE_ENV === "development" ? '' : '/cesium_editor'